import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BlogPageService {

    private API_URL= environment.API_URL;

    constructor(
        private http : HttpClient
    ) {}



    getData(){
        let url = `${this.API_URL}/blog-posts?populate=post_tags,category,image&sort=updatedAt:desc`;

        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

    getSpotlight(){

        let url = `${this.API_URL}/blog-posts?populate=*&sort=publishedAt:desc&filters[spotlight]=true`;

        return this.http.get(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }
}
